<template>
  <div id="contents" class="recent contents">
    <template v-if="recentList.length">
      <p class="msgHeader">
        {{ $t('recent.recently_viewed_items_limit_D03') }}
      </p>
      <div class="cartProduct">
        <ul class="listTypeCart">
          <li
            class="productItem"
            v-for="(product, index) in recentList"
            :key="index"
          >
            <button
              type="button"
              class="btDelete"
              @click="openModalRemoveRecentProduct(product.productId)"
            >
              <span class="icon iconDel"></span>
              <span class="accessibilityHide">
                {{ $t('common.accessibility.delete') }}
              </span>
            </button>
            <product-item
              :product="product"
              v-bind:isSaleAfter="true"
            ></product-item>
          </li>
        </ul>
      </div>
    </template>
    <contents-none
      v-else
      :none-text="$t('recent.no_recently_viewed_items_C09')"
    ></contents-none>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContentsNone from '@/views/base/ContentsNone'
import ProductItem from '@/views/base/ProductItem'

export default {
  components: {
    ContentsNone,
    ProductItem
  },
  computed: {
    ...mapGetters('recent', ['recentList'])
  },
  methods: {
    ...mapActions('modal', ['openModalRemoveRecentProduct']),
    ...mapActions('recent', ['getRecentProductList'])
  },
  mounted() {
    this.getRecentProductList()
  }
}
</script>

<style lang="scss">
.recent {
  .msgHeader {
    text-align: left;
  }
}
</style>
